import React from 'react'

const ThumbnailTitle: React.FC<{ title: string }> = ({ title }) => {
  return (
    <h1 className='text-thumbnail-title 2xl:text-thumbnail-title-2xl font-semibold text-[2rem]'>
      {title}
    </h1>
  )
}

export default ThumbnailTitle
